export default __webpack_public_path__ + "img/vector-left-black.629238cf.svg";